<template>
  <div
    class="question-details-wrapper"
    :class="question.precondition ? 'follow-up' : ''"
  >
    <div
      class="question-card card d-flex flex-column justify-content-between h-100"
    >
      <div class="alert alert-info m-5">
        <span
          v-if="question.error.code === 'NOT_ENOUGH_RESPONSES'"
          class="text-info"
        >
          {{ $t('freetext.notEnoughResponses') }}
        </span>
      </div>
      <div
        v-if="question.messages"
        class="card-footer d-flex align-items-center"
      >
        <p class="card-question mb-0">{{ $tr(question.messages, 'title') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionDetailsNotEnoughResponses',
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    loadQuestionResponses: {
      type: Function,
      default: () => null
    },
    freeTextVisualizerView: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.question-details-wrapper {
  height: 100%;
  &.follow-up {
    margin-top: 10px;
    height: calc(100% - 10px);
    .question-card {
      background-color: rgba(var(--kt-gray-200-rgb), 0.5);
    }
  }
}
</style>
